// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ChartJS } from "@components";
import type { ComplianceReportData } from "@modules/reporting/reducer/trends/compliance/types";

type OwnProps = $Exact<{
  reportData: ComplianceReportData,
  weeklyPeriod: boolean,
  reportDetails: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendComplianceChart = ({ reportData, t, reportDetails }: Props) => {
  const trendType = ((reportDetails || {}).filters || {}).complianceType || "";
  return (
    <ChartJS
      type="bar"
      title={t("TRENDS_COMPLIANCE_HEADLINES_LABEL", { trendName: t(trendType) })}
      data={{
        labels: ((reportData.headlines || {}).periods || []).map(item => item.period),
        datasets: [
          {
            label: t(trendType),
            data: ((reportData.headlines || {}).periods || []).map(
              item => item.compliancePercentage,
            ),
          },
        ],
      }}
      options={{
        height: 200,
        wrapXAxisLabels: true,
        scales: {
          y: { title: { display: true, text: t("COMPLIANCE_PERCENTAGE") } },
        },
      }}
    />
  );
};

export default localize()(TrendComplianceChart);
